import { Route, Switch } from 'react-router-dom';
import { ROOT, SEARCH } from './constants';
import { Home, Page, Search } from './components';

const HelpCenter = () => (
  <Switch>
    <Route exact path={`${ROOT}`} component={Home} />
    <Route path={`${SEARCH}/:query?`} component={Search} />
    <Route path={`${ROOT}/:collectionSlug/:articleSlug?`} component={Page} />
  </Switch>
);

export default HelpCenter;
